import styled from 'styled-components';
import { mediaQuery } from '../../common/styles/styleUtil';

export const CardWrapper = styled.div`
  position: relative;
  width: 356px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #d2d5da;
  border-radius: 3px;
  margin: 0 2px;

  &:hover {
    cursor: pointer;
  }

  @media (${mediaQuery.tablet}) {
    width: 300px;
    margin: 0;
  }
`;

export const CardImageWrapper = styled.div`
  width: 100%;
  height: 202px;
  background-color: #f3f4f6;

  @media (${mediaQuery.tablet}) {
    height: 168px;
  }

  .lazy-image-wrapper {
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
  }
`;

export const CardLogoWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 60px;
  transform: translateY(-30px);
  text-align: center;
`;

interface LogoProps {
  bgColor: string;
}

export const CardLogo = styled.img<LogoProps>`
  display: inline-block !important;
  width: 120px;
  height: 100%;
  border: 1px solid #d2d6da;
  border-radius: 5px;
  padding: 10px 15px;
  object-fit: contain;
  background-color: ${(props) => props.bgColor || '#ffffff'};
`;

export const CardInfoPanel = styled.div`
  width: 100%;
  padding: 44px 16px 16px 16px;
  text-align: center;
  color: #333f48;
`;

export const CardTitle = styled.h2`
  font-size: 18px;
  line-height: 22px;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 400;
`;

export const Address = styled.div`
  font-size: 16px;
  font-weight: 300;
  height: 24px;
  line-height: 24px;
  margin-bottom: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PropertyInfo = styled.div`
  font-size: 16px;
  font-weight: 300;
  height: 24px;
  line-height: 24px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PriceInfo = styled.div`
  font-size: 16px;
  font-weight: 300;
  height: 24px;
  line-height: 24px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Developer = styled.div`
  font-size: 16px;
  font-weight: 300;
  height: 22px;
  line-height: 24px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
